import React from 'react';

const DEFAUlT_TEXT = 'No data available';

const NoData = ({ text = DEFAUlT_TEXT, icon = true }) => (
  <div className="no-data__container">
    <p className="no-data__text">{text}</p>
    {icon && <p className="no-data__icon" />}
  </div>
);

export default NoData;
